
import { Sparkles } from "lucide-react";
import { Client } from "../../types";

interface FieldIndicatorProps {
  fieldName: keyof Client;
  fieldsWithNewData: Set<keyof Client>;
}

export const FieldIndicator: React.FC<FieldIndicatorProps> = ({ fieldName, fieldsWithNewData }) => {
  if (!fieldsWithNewData.has(fieldName)) {
    return null;
  }
  
  return (
    <Sparkles className="w-3 h-3 text-yellow-500 dark:text-yellow-400 ml-1 inline" aria-label="new data available"/>
  );
};
